"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateDesignationSchema = exports.createDesignationSchema = exports.designationShape = void 0;
const zod_1 = require("zod");
const employee_master_schema_1 = require("./employee-master.schema");
/**
 * Employee Master enterprise rebuild — a real, tenant-scoped job-title
 * catalog. `defaultRoleId` is what makes "Role assigned automatically
 * based on designation" real: `EmployeeProvisioningService` reads this
 * field at login-creation time, it is not a hardcoded designation-name
 * switch statement in application code.
 */
exports.designationShape = {
    code: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(150),
    employeeType: employee_master_schema_1.employeeTypeEnum.nullable().optional(),
    defaultRoleId: zod_1.z.string().uuid().nullable().optional(),
    isActive: zod_1.z.boolean().optional(),
};
exports.createDesignationSchema = zod_1.z.object(exports.designationShape);
exports.updateDesignationSchema = exports.createDesignationSchema.partial();
//# sourceMappingURL=designation.schema.js.map